import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Layout, Row, Col, Spin, } from 'antd';
import { useI18n } from '../I18n/index.js';
import LangSelect from '../LangSelect/index.js';
import GenericAppIcon from './GenericAppIcon/index.js';
const { Header } = Layout;
const BeeyAppHeader = ({ appName, appIcon, locales }) => {
    const { intl, selectLocale } = useI18n();
    const [isConnected, setIsConnected] = useState(window.navigator.onLine);
    const updateConnected = () => {
        setIsConnected(window.navigator.onLine);
    };
    const handleLangChange = (lang) => {
        selectLocale(lang);
    };
    useEffect(() => {
        window.addEventListener('offline', updateConnected);
        window.addEventListener('online', updateConnected);
        return () => {
            window.removeEventListener('offline', updateConnected);
            window.removeEventListener('online', updateConnected);
        };
    });
    return (_jsx(Header, { children: _jsxs(Row, { justify: "space-between", children: [_jsx(Col, { children: _jsxs("div", { className: "app-brand", children: [_jsx("div", { className: "app-brand__logo", children: appIcon === undefined ? _jsx(GenericAppIcon, {}) : appIcon }), _jsx("div", { className: "app-brand__name", children: appName })] }) }), _jsx(Col, { children: isConnected ? null : (_jsxs("div", { className: "reconnecting", children: [_jsx("p", { children: intl.formatMessage({ id: 'reconnecting' }) }), _jsx(Spin, {})] })) }), locales !== undefined && locales.length > 0 ? (_jsx(Col, { children: _jsx(LangSelect, { langs: locales, value: intl.locale, onChange: handleLangChange }) })) : null] }) }));
};
export default BeeyAppHeader;
